export const PUBLIC_WORKER_POOL_ID = "public-worker-pool";
export const PUBLIC_WORKER_POOL_URL = `/worker-pool/${PUBLIC_WORKER_POOL_ID}`;
export const PUBLIC_WORKER_POOL_NAME = "Public worker pool";

export const NO_PRIVATE_WORKERS_AVAILABLE_MESSAGE = "This worker pool has no available workers";
export const NO_PUBLIC_WORKERS_AVAILABLE_MESSAGE =
  "There are no public workers available for your account";
